import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { db } from "../firebase"; // Firebase setup
import { collection, getDocs } from "firebase/firestore";

// Register the required components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const ProgressChart = () => {
  const [chartData, setChartData] = useState(null);

  const fetchProgressData = async () => {
    const dailyTaskCollection = collection(db, "dailyTasks");
    const snapshot = await getDocs(dailyTaskCollection);
    const data = [];

    snapshot.forEach((doc) => {
      const { subtasks } = doc.data();
      const completedTasks = subtasks.filter((task) => task.completed).length;
      data.push({
        date: doc.id, // Firestore document ID is the date
        completed: completedTasks,
      });
    });

    // Sort data by date
    data.sort((a, b) => new Date(a.date) - new Date(b.date));

    const labels = data.map((entry) => entry.date);
    const completedCounts = data.map((entry) => entry.completed);

    setChartData({
      labels,
      datasets: [
        {
          label: "Tasks Completed",
          data: completedCounts,
          borderColor: "#4CAF50",
          backgroundColor: "rgba(76, 175, 80, 0.2)",
          fill: true,
          tension: 0.4,
        },
      ],
    });
  };

  useEffect(() => {
    fetchProgressData();
  }, []);

  return (
    <Container>
      <h2>Progress Chart</h2>
      {chartData ? (
        <Line
          data={chartData}
          options={{
            responsive: true,
            plugins: {
              legend: {
                display: true,
                position: "top",
              },
            },
            scales: {
              x: {
                title: {
                  display: true,
                  text: "Dates",
                },
              },
              y: {
                title: {
                  display: true,
                  text: "Number of Tasks Completed",
                },
                beginAtZero: true,
              },
            },
          }}
        />
      ) : (
        <p>Loading chart...</p>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 54%;
  /* max-width: 1100px; */
  padding: 20px;
  background-color: #171c29;
  color: white;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  h2 {
    font-weight: 300;
    text-align: center;
    margin-bottom: 20px;
  }
  @media (max-width: 1420px) {
    width: 48%;
  }
  @media (max-width: 1100px) {
    width: 100%;
  }
  @media (max-width: 500px) {
    max-width: 100%;
    width: 100%;
  }
`;

export default ProgressChart;
